module.exports = "././img/dlgrma_logo.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/dlgrma_logo.svg
// module id = 818
// module chunks = 0